<template>
	<type-wrapper class="type-K" limit>
		<type-grid :row="row" margin v-for="(item, index) in showData" :key="index">
			<div class="type-K-data">
				<type-image width="50%" mode="widthFix" :src="item.logo"></type-image>
				<type-title padding="25px 0" medium v-if="item.title">{{ item.title }}</type-title>
				<type-content large v-if="item.content" :style="contentColor">{{ item.content }}</type-content>
			</div>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// N分栏不同主题图文说明
	import mixin from '../mixin.js'
	export default {
		name: 'type-K',
		mixins: [ mixin ],
		computed: {
			row() {
				return this.showData.length > 3 ? 3 : this.showData.length;
			}
		}
	}
</script>

<style scoped lang="less">
	.type-K{
		display: flex;
		flex-wrap: wrap;
		.type-K-data{
			padding: 20px;
			text-align: center;
			background-color: #FFFFFF;
			box-shadow: inset 0 1px 1px rgba(0, 0, 0,  .075), 0 0 8px rgba(102, 175, 233, .6);
		}
	}
</style>
